/**
 * Environment names
 */
export enum Environment {
  DEV_LOCAL = "dev-local",
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
}

/**
 * Environment variable keys
 */
export enum EnvironmentVariableKeys {
  VITE_API_BASE_URL = "VITE_API_BASE_URL",
  // Add more environment variables as needed
}

/**
 * Base environment configuration interface
 */
export interface EnvironmentConfig {
  apiBaseUrl: string;
  s3BaseUrl: string;
  /** Public web (sploot-web-v3) origin; hosts the `/vet-preview/:token` iframe. */
  webBaseUrl: string;
}